import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#121416] text-white py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-2">
            <span className="text-xl font-[var(--font-display)] mb-4 block">Ellis Row</span>
            <p className="text-sm text-white/60 max-w-md leading-relaxed">
              A Mods Enterprises development bringing modern architecture and thoughtful design to central Iowa.
            </p>
            <div className="mt-6">
              <a 
                href="https://modsenterprises.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-white/40 hover:text-white/70 transition-colors tracking-wider uppercase"
              >
                ← Back to Mods Enterprises
              </a>
            </div>
          </div>
          <div>
            <h3 className="font-medium mb-4 text-sm uppercase tracking-wider text-white/80">Navigate</h3>
            <div className="flex flex-col space-y-3 text-sm">
              <Link to="/units" className="text-white/60 hover:text-white transition-colors">
                Browse Units
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-white transition-colors">
                Contact
              </Link>
            </div>
          </div>
          <div>
            <h3 className="font-medium mb-4 text-sm uppercase tracking-wider text-white/80">Legal</h3>
            <div className="flex flex-col space-y-3 text-sm">
              <Link to="/terms" className="text-white/60 hover:text-white transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-white/60 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/fair-housing" className="text-white/60 hover:text-white transition-colors">
                Fair Housing
              </Link>
            </div>
            <div className="mt-6">
              <p className="text-xs text-white/40">Secure payments by Stripe</p>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-xs text-white/40">
          <p>&copy; 2026 Ellis Row · A Mods Enterprises Development</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <p>Breaking Ground Summer 2026</p>
            <p>🏡 Equal Housing Opportunity</p>
          </div>
        </div>
      </div>
    </footer>
  );
}